import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST, PUT } from "../utils/Methods";

export const GetAllExamQuestion = createAsyncThunk(
  "test/exam/get-all-test-question",
  async (filter, { rejectWithValue }) => {
    try {
      console.log(filter, "filter");

      const res = await GET(
        `${`${APIS.TestQuestion?.AllTestQuestion}?id=${filter?.id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StudentResponse = createAsyncThunk(
  "test/exam/student-response",
  async ({ id, user_answer_id }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.TestQuestion?.updateUserAnswer}/${id}`, {
        user_answer_id: user_answer_id,
      });

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const FinalSubmit = createAsyncThunk(
  "test/exam/final-submit",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.TestQuestion?.final_submit}/${id}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "contain",
  initialState: {
    data: [],
    resultData: [],
    single: null,
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllExamQuestion.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllExamQuestion.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllExamQuestion.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StudentResponse.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(StudentResponse.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        // ✅ only store response
        state.savedResponse = action.payload;
      })

      .addCase(StudentResponse.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(FinalSubmit.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(FinalSubmit.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.resultData = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(FinalSubmit.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
